import { RouterStore } from 'mobx-react-router';
import PlayerStore from './PlayerStore';

const RoutingStore = new RouterStore();
const stores = {
  RoutingStore,
  PlayerStore
};

export default stores;